import type { FC } from "react";
import { Container, Link, LinkKind, NBSP as Nbsp, Row } from "@viagogo/core/ui";
import { Content, useContent } from "src/shared/components/content";
import { useWriteUrl } from "src/shared/utils/url-builder";
import {
  ContentDivider,
  StyledImageCol,
  StyledTextBodyDiv,
  StyledTextHeading,
  StyledTextRow,
  TextWrapper,
} from "src/website-apps/responsive/stubhub-about-us/components/stubhub/styled-components";
import { StyledTitle } from "src/website-apps/shared/components/branding/styled-components";
import { Image, ImageSize } from "src/website-apps/shared/components/image";

interface PromiseProps {
  readonly images: readonly string[];
}

export const Promise: FC<PromiseProps> = ({ images }) => {
  const legalUrl = useWriteUrl("/legal");
  const hereContent = useContent("cid$#1937328#");
  const termsContent = useContent("cid$#1937333#");
  const fullPolicyContent = useContent("cid$#1937336#");

  return (
    <>
      <ContentDivider />
      <TextWrapper>
        <Container>
          <Row>
            <StyledTitle>
              <Content id="cid$#1937311#" />
            </StyledTitle>
          </Row>
          <StyledTextRow style={{ display: "block" }}>
            <StyledTextHeading style={{ display: "inline-block" }}>
              <Content id="cid$#1937314#" />
            </StyledTextHeading>
            <Nbsp />
            <Content id="cid$#1937316#" />
          </StyledTextRow>
          <StyledTextRow>
            <StyledTextHeading>
              <Content id="cid$#1937318#" />
            </StyledTextHeading>
          </StyledTextRow>
          <StyledTextRow style={{ display: "block" }}>
            <div>
              <Content id="cid$#1937319#" />
            </div>
            <div>
              <Content id="cid$#1937320#" />
            </div>
            <div>
              <Content id="cid$#1937322#" />
            </div>
            <div>
              <Content id="cid$#1937324#" />
            </div>
          </StyledTextRow>
          <StyledTextRow>
            <Content id="cid$#1937326#" />
            <Nbsp />
            <Link kind={LinkKind.Primary} title={hereContent} url={legalUrl}>
              {hereContent}
            </Link>
          </StyledTextRow>
          <StyledTextRow>
            <StyledTextHeading>
              <Content id="cid$#1937330#" />
            </StyledTextHeading>
          </StyledTextRow>
          <StyledTextRow>
            <Content id="cid$#1937332#" />
            <Nbsp />
            <Link kind={LinkKind.Primary} title={termsContent} url={legalUrl}>
              {termsContent}
            </Link>
          </StyledTextRow>
          <StyledTextRow>
            <Content id="cid$#1937335#" />
            <Nbsp />
            <Link kind={LinkKind.Primary} title={fullPolicyContent} url={legalUrl}>
              {`${fullPolicyContent} ›`}
            </Link>
          </StyledTextRow>
        </Container>
      </TextWrapper>
      <ContentDivider />
      <TextWrapper>
        <Container>
          <Row>
            <StyledTitle>
              <Content id="cid$#1937461#" />
            </StyledTitle>
          </Row>
          <Row>
            <StyledImageCol span={[12, 12, 12, 4]}>
              <StyledTextHeading>
                <Content id="cid$#1937462#" />
              </StyledTextHeading>
              <Image alt="Promise" src={images[0]} size={ImageSize.Square6Col} />
              <StyledTextBodyDiv>
                <Content id="cid$#1937463#" />
              </StyledTextBodyDiv>
            </StyledImageCol>
            <StyledImageCol span={[12, 12, 12, 4]}>
              <StyledTextHeading>
                <Content id="cid$#1937464#" />
              </StyledTextHeading>
              <Image alt="Promise" src={images[1]} size={ImageSize.Square6Col} />
              <StyledTextBodyDiv>
                <Content id="cid$#1937466#" />
              </StyledTextBodyDiv>
            </StyledImageCol>
            <StyledImageCol span={[12, 12, 12, 4]}>
              <StyledTextHeading>
                <Content id="cid$#1937467#" />
              </StyledTextHeading>
              <Image alt="Promise" src={images[2]} size={ImageSize.Square6Col} />
              <StyledTextBodyDiv>
                <Content id="cid$#1937468#" />
              </StyledTextBodyDiv>
            </StyledImageCol>
          </Row>
        </Container>
      </TextWrapper>
    </>
  );
};
